module.exports = __webpack_public_path__ + "img/log-out.70adb10f.svg";